
import React, { useState } from "react";
import AuthHeader from "./auth/AuthHeader";
import SignInForm from "./auth/SignInForm";
import SignUpForm from "./auth/SignUpForm";

export interface LoginProps {
  onSuccess?: () => void;
  initialShowSignUp?: boolean;
}

const LoginComponent: React.FC<LoginProps> = ({ onSuccess, initialShowSignUp = false }) => {
  const [isSignUp, setIsSignUp] = useState(initialShowSignUp);

  const toggleForm = () => {
    setIsSignUp(!isSignUp);
  };

  return (
    <div className="w-full max-w-md mx-auto px-8">
      <AuthHeader isSignUp={isSignUp} />
      
      <div className="glass-card rounded-xl p-6 animate-fade-in delay-100 bg-white/80 border border-[#E4002B]/10">
        {isSignUp ? (
          <SignUpForm onToggleForm={toggleForm} />
        ) : (
          <SignInForm onSuccess={onSuccess} onToggleForm={toggleForm} />
        )}
      </div>
    </div>
  );
};

export default LoginComponent;
